module.exports = __webpack_public_path__ + "img/unavailable-location.1d8bd23f.svg";